module.exports = __webpack_public_path__ + "static/media/02-dr-syed.168c739b.png";